import React, { useState } from 'react';
import ModalButton from './ModalButton';

const CodeVerificationModal = ({checkCode, email, proceed, closeModal})=>{

	const [ count, setCount ] = useState(0);
	const [ enteredCode, setEnteredCode ] = useState("");

	const [ message, setMessage ] = useState("");

	const checkCodeLocal = () => {
		checkCode(enteredCode).then(response=>{

			if (!response.success) {
				const used = count + 1;
				if (used >= 3) {
					setMessage("Sorry, you have used all your attempts.  We are not able to create an account for you at this time.");
				} else {
					setMessage("The code you entered was incorrect.  You have " + (3 - used) + " attempts left");
				}
				setCount(used);
			} else {
				proceed(enteredCode);
			}
		});
	}
	return <div>
		<div>Great, first we need to confirm you are who you say you are.  We've sent an email
		to <strong>{email}</strong>&nbsp; with a confirmation code.  Please enter the code below.
		If you don't see the email in a couple of minutes, please check your spam folder</div>
		<div className="message" style={{visibility: !!message ? "visible" : "hidden"}}>{!!message ? message : "Placeholder"}</div>
		<div className="center"><input value={enteredCode} onChange={e=>setEnteredCode(e.target.value)} /></div>
		<ModalButton text="Verify" onClick={checkCodeLocal} disabled={count >= 3} showBail={true} bail={closeModal} />
	</div>
}

export default CodeVerificationModal;